/*-------------------------------------------------------
 The following JavaScript functions control Booking basket
---------------------------------------------------------*/

var TECL_BottomNavPopOut = {

    // Toggle the open state of the navigation panel
    ToggleNavOpen: function() {
        if ($("#bottomNavPopOutOpenIcon").hasClass("hidden")) {
            TECL_BottomNavPopOut.CloseNav();
        } else {
            TECL_BottomNavPopOut.OpenNav();
        }
    },

    // Open the bottom navigation panel and show the contents
    OpenNav: function() {
        $("#bottomNavPopOutCloseIcon").removeClass("hidden");
        $("#bottomNavPopOutOpenIcon").addClass("hidden");
        $("#bottomNavPopOutContent").removeClass("hidden");

        var finalHeight;
        var screenHeight = document.documentElement.clientHeight;
        var maxHeight = Math.ceil((screenHeight / 100) * 90);
        var screenWidth = document.documentElement.clientWidth;

        var isMobile = screenHeight < 768 || screenWidth < 768;

        if (isMobile) {
            $("body").addClass("stopScrolling");
     
            // Remove any html heights or widths and allow css control the sizes 
            document.getElementById("bottomNavPopOut").style.width = null;
            document.getElementById("bottomNavPopOut").style.height = null;
        } else {

            $("body").removeClass("stopScrolling");
            var newHeight;

            if ($("#bookingBasketUserDetails").hasClass("hidden")) {
                // the enquire list is showing so change the height depending on the content

                // Work out the height the popup should be
                newHeight = 240;
                $("#bottomNavPopOutContent").find(".bookingBasketItem").each(function() {
                    newHeight += $(this).outerHeight();
                });

                if (newHeight > maxHeight) {
                    newHeight = maxHeight;
                }

                finalHeight = newHeight + "px";

            } else {
              // User details is displayed
                newHeight = 70;
                newHeight += $("#bookingBasketUserDetails").outerHeight();

                if (newHeight > maxHeight) {
                    newHeight = maxHeight;
                }

                finalHeight = newHeight + "px";
            }
            // Set the height
            document.getElementById("bottomNavPopOut").style.height = finalHeight;
        }
    },

    // Close the bottom navigation panel and hide the contents
    CloseNav: function() {
        $("#bottomNavPopOutCloseIcon").addClass("hidden");
        $("#bottomNavPopOutOpenIcon").removeClass("hidden");
        document.getElementById("bottomNavPopOut").style.height = "50px";
        $("#bottomNavPopOutContent").addClass("hidden");
        $("body").removeClass("stopScrolling");
    },

    // Display the bottom navigation panel and show it's contents
    DisplayList: function(partialViewHtml, openContent) {
        var bottomNavPopOut = $("#bottomNavPopOut");

        if (bottomNavPopOut && bottomNavPopOut.length > 0) {
            var bottomNavPopOutContent = $("#bottomNavPopOutContent");

            if ( !partialViewHtml ) {
                alert( "Something went wrong whilst loading your basket. "
                     + "This error has been logged. Please try again later." );
            }

            if (partialViewHtml && bottomNavPopOutContent) {
                bottomNavPopOut.removeClass("hidden");
                bottomNavPopOutContent.html(partialViewHtml);

                if (openContent) {
                    TECL_BottomNavPopOut.OpenNav();
                } else {
                    TECL_BottomNavPopOut.CloseNav();
                }
            } else {
                bottomNavPopOut.addClass("hidden");
            }
        }
    },

    // Hide and reset the popup
    Hide: function() {
        var bottomNavPopOut = $("#bottomNavPopOut");

        if (bottomNavPopOut && bottomNavPopOut.length > 0) {
            var bottomNavPopOutContent = $("#bottomNavPopOutContent");

            if (bottomNavPopOutContent && bottomNavPopOutContent.length > 0) {
                bottomNavPopOut.addClass("hidden");
                bottomNavPopOutContent.html("");
            }
        }
    }

}
